import { type CameraSlice, createStoreHooks } from '../../../../canvas/core';
import type { PageLayoutSlice } from '../../../core';

type UseActivePageDeps = CameraSlice & PageLayoutSlice;

const { useStore } = createStoreHooks<UseActivePageDeps>();

export const useActivePage = () => {
  return useStore(state => state.pageLayout.activeId);
};
